import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { $mapLoaded } from '../../../models/mapModel/index.js';
import { $investProDistricts } from '../../../models/investProModel/index.js';

function InvestProDistricts() {
  const mapLoaded = useUnit($mapLoaded);
  const polygons = useUnit($investProDistricts);

  const createLayer = (update) => {
    const investProAdminData = {
      type: 'FeatureCollection',
      features: polygons,
    };

    if (update) {
      window.map
        .getSource('invest_pro_districts_source')
        .setData(investProAdminData);
    } else {
      if (!window.map.getSource('invest_pro_districts_source')) {
        window.map.addSource('invest_pro_districts_source', {
          type: 'geojson',
          data: investProAdminData,
        });
      }

      if (!window.map.getLayer('invest_pro_districts_layer')) {
        window.map.addLayer({
          id: 'invest_pro_districts_layer',
          type: 'fill',
          source: 'invest_pro_districts_source',
          paint: {
            'fill-color': 'green',
            'fill-opacity': [
              'interpolate',
              ['linear'],
              ['zoom'],
              4.3,
              0,
              5,
              0.8,
              11,
              0,
            ],
            'fill-outline-color': '#000000',
          },
        });
      }
    }
  };

  useEffect(() => {
    if (mapLoaded && polygons) {
      if (window.map.getLayer('invest_pro_districts_layer')) {
        createLayer(true);
      } else {
        setTimeout(() => {
          createLayer(false);
        }, 500);
      }
    }
  }, [mapLoaded, polygons]);

  return null;
}

export default InvestProDistricts;
